// @ts-nocheck
import React from 'react';
import StaffTournamentPage from '@/pages/staff/StaffTournamentPage';

const DemoScheduling: React.FC = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Scheduling & Live Scoring Demo</h1>
        <p className="text-muted-foreground">Court/field scheduling, live scoring, and printable views</p>
      </div>
      <StaffTournamentPage />
    </div>
  );
};

export default DemoScheduling;
